import axios from 'axios';

const baseHeader = {
  Accept: 'application/json',
  'X-Quoine-API-Version': 2,
  'X-Quoine-Device': 'web-native',
  'Content-Type': 'application/json',
};


export class Cache {
  /**
   * Cache storage
   * { url: { response, expires }
   */
  storage = {}

  getCache(url, method) {
    if (!url || !method) return null;
    const key = `${url}${method}`;
    // Check if it's not cached
    const cache = this.storage[key];
    if (!cache) return null;

    // Check if it's not outdated
    const ts = +new Date();
    if (ts > cache.expires) return null;

    return cache;
  }

  setCache(url, method, expires, request) {
    const key = `${url}${method}`;
    this.storage[key] = {
      request,
      expires,
    };
  }
}

const cacheStorage = new Cache();


const main = (method, url, options = {}) => {
  if (options.useCache !== false) {
    const cached = cacheStorage.getCache(url, method);
    if (cached && cached.request) {
      return cached.request;
    }
  }

  const header = options.header || {};
  const headers = { ...baseHeader, ...header };

  const config = {
    baseURL: process.env.API_HOST,
    headers,
    method,
    url,
  };
  if (options.body) {
    config.data = options.body;
  }
  const expires = (+new Date()) + (3000 * 60);
  let request;
  const promise = new Promise((res) => {
    request = axios(config)
      .then(raw => raw.data)
      .then(data => {
        if (options.useCache !== false) res(data);
        return data;
      });
  });
  if (options.useCache !== false) cacheStorage.setCache(url, method, expires, promise);
  return request;
};

const REST = {
  get: main.bind(null, 'get'),
  post: main.bind(null, 'post'),
  put: main.bind(null, 'put'),
  del: main.bind(null, 'delete'),
};

export default REST;



// WEBPACK FOOTER //
// ../src/resources/REST/index.js